import {
  createTotvsIntegrationAsync,
  deleteTotvsIntegrationAsync,
  getAllTotvsIntegrationsAsync,
  getTotvsIntegrationByIdAsync,
  updateTotvsIntegrationAsync,
} from '../../index';
import { useMutation } from 'react-query';

export const useCreateTotvsIntegrationAsync = () =>
  useMutation(createTotvsIntegrationAsync);

export const useGetTotvsIntegrationByIdAsync = () =>
  useMutation(getTotvsIntegrationByIdAsync);

export const useGetAllTotvsIntegrationsAsync = () =>
  useMutation(getAllTotvsIntegrationsAsync);

export const useUpdateTotvsIntegrationAsync = () =>
  useMutation(updateTotvsIntegrationAsync);

export const useDeleteTotvsIntegrationAsync = () =>
  useMutation(deleteTotvsIntegrationAsync);
